import { defaultApi } from "./api";

function stripBlogMarkup(value = "") {
  return String(value)
    .replace(/<[^>]*>/g, " ")
    .replace(/\s+/g, " ")
    .trim();
}

function extractBlogItems(payload) {
  if (Array.isArray(payload?.data)) {
    return payload.data;
  }

  if (Array.isArray(payload?.data?.data)) {
    return payload.data.data;
  }

  return [];
}

function isActiveBlog(blog) {
  return !blog?.status || String(blog.status).toLowerCase() === "active";
}

function normalizeBlogItem(blog) {
  return {
    ...blog,
    blog_subject: stripBlogMarkup(blog?.blog_subject || ""),
    meta_title: stripBlogMarkup(blog?.meta_title || ""),
    meta_description: stripBlogMarkup(blog?.meta_description || ""),
    blog_content: stripBlogMarkup(blog?.blog_content || ""),
    blog_content_html: blog?.blog_content || "",
    file: blog?.file || "",
  };
}

function sortBlogsByLatest(firstBlog, secondBlog) {
  const firstTime = new Date(firstBlog?.created_at || 0).getTime();
  const secondTime = new Date(secondBlog?.created_at || 0).getTime();

  return secondTime - firstTime;
}

export async function getBlogs() {
  const res = await defaultApi.get("/admin/getBlogs");
  const normalizedBlogs = extractBlogItems(res.data)
    .filter(isActiveBlog)
    .map(normalizeBlogItem)
    .sort(sortBlogsByLatest);

  return {
    result: res.data?.result ?? (normalizedBlogs.length ? 1 : 0),
    msg: res.data?.msg || (normalizedBlogs.length ? "Data Found!" : "Data Not Found!"),
    data: normalizedBlogs,
    pagination: res.data?.data || null,
  };
}

function normalizeBlogAdItem(ad) {
  return {
    ...ad,
    id: ad?.id,
    title: stripBlogMarkup(ad?.title || ""),
    image: ad?.image || "",
    category_id: ad?.category_id,
    status: ad?.status,
  };
}

export async function getBlogAds() {
  const res = await defaultApi.get("/admin/getBlogAds");
  const ads = Array.isArray(res.data?.data) ? res.data.data : [];

  return {
    result: res.data?.result ?? (ads.length ? 1 : 0),
    msg: res.data?.msg || (ads.length ? "Data Found!" : "Data Not Found!"),
    data: ads
      .filter((ad) => String(ad?.status) === "1" || String(ad?.status).toLowerCase() === "active")
      .map(normalizeBlogAdItem),
  };
}
